document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("search_form");
  if (!form) return;

  const fieldGroup = form.querySelector(".field_group");
  const originalButton = form.querySelector(".field_group_button");
  const floatButton = form.querySelector(".field_group_button_float");

  if (fieldGroup && originalButton && floatButton && "IntersectionObserver" in window) {
    let buttonInView = true;
    let formInView = false;

    const updateFloatButton = () => {
      const show = formInView && !buttonInView;
      floatButton.classList.toggle("is-show", show);
      floatButton.setAttribute("aria-hidden", show ? "false" : "true");
      floatButton.tabIndex = show ? 0 : -1;
    };

    new IntersectionObserver((entries) => {
      buttonInView = entries[0].isIntersecting;
      updateFloatButton();
    }).observe(originalButton);

    new IntersectionObserver((entries) => {
      formInView = entries[0].isIntersecting;
      updateFloatButton();
    }).observe(fieldGroup);
  }

  const shisetsukubun1 = document.getElementById("shisetsukubun1");
  const shisetsukubun2 = document.getElementById("shisetsukubun2");
  const shisetsukubun3 = document.getElementById("shisetsukubun3");
  const formPref = form.querySelector(".form_pref");
  const formPref02 = form.querySelector(".form_pref02");
  const prefInputs = form.querySelectorAll('.form_pref input[name="pref"]');
  const pref02Inputs = form.querySelectorAll('.form_pref02 input[name="pref02"]');

  if (!shisetsukubun1 || !shisetsukubun2 || !shisetsukubun3) return;

  const setDisabled = (inputs, field, disabled) => {
    inputs.forEach((input) => {
      input.disabled = disabled;
      if (disabled) {
        input.checked = false;
      }
    });
    if (field) {
      field.classList.toggle("disable", disabled);
    }
  };

  const updatePrefAvailability = () => {
    const onlyShisetsukubun1 =
      shisetsukubun1.checked &&
      !shisetsukubun2.checked &&
      !shisetsukubun3.checked;

    const shisetsukubun2or3Without1 =
      !shisetsukubun1.checked &&
      (shisetsukubun2.checked || shisetsukubun3.checked);

    setDisabled(pref02Inputs, formPref02, onlyShisetsukubun1);
    setDisabled(prefInputs, formPref, shisetsukubun2or3Without1);
  };

  [shisetsukubun1, shisetsukubun2, shisetsukubun3].forEach((input) => {
    input.addEventListener("change", updatePrefAvailability);
  });

  updatePrefAvailability();
});
